export const uiInitState = {
  alert: {
    message: null,
    icon: null,
    severity: "info",
    time: null,
  },
  drawer: {
    open: false,
    placeHolder: "Buscar",
    action: null,
  },

  chat: {
    open: false,
  },
};

export const uiReducers = {
  openAlert: (state, { payload }) => {
    state.alert.message = payload?.message;
    state.alert.icon = payload?.icon;
    state.alert.severity = payload?.severity || "info";
    state.alert.time = payload?.time || 5000;
  },

  closeAlert: (state) => {
    state.alert.message = null;
    state.alert.icon = null;
    state.alert.severity = "info";
    state.alert.time = 5000;
  },

  openSearchDrawer: (state) => {
    state.drawer.open = true;
    state.drawer.action = "SEARCH_USERS";
    state.drawer.placeHolder = "Buscar usuarios";
  },

  openGroupsDrawer: (state) => {
    state.drawer.open = true;
    state.drawer.action = "SEARCH_GROUPS";
    state.drawer.placeHolder = "Buscar grupos";
  },

  closeSearchDrawer: (state) => {
    state.drawer.open = false;
  },

  openChatMenu: (state) => {
    state.chat.open = true;
    state.drawer.action = null;
  },

  closeChatMenu: (state) => {
    state.chat.open = false;
  },
};
